import { Link } from "react-router-dom";
import { thumbUrl } from "@/lib/api";

export function Logo({ size = "md", linkTo = "/", className = "", showText = true, logoUrl }) {
  const sizes = {
    sm: { box: "h-8 w-8 sm:h-9 sm:w-9", text: "text-sm sm:text-base", subtext: "text-[9px] sm:text-[10px]" },
    md: { box: "h-9 w-9 sm:h-11 sm:w-11", text: "text-sm sm:text-lg", subtext: "text-[9px] sm:text-xs" },
    lg: { box: "h-11 w-11 sm:h-14 sm:w-14", text: "text-base sm:text-xl", subtext: "text-[10px] sm:text-xs" },
    xl: { box: "h-16 w-16 sm:h-20 sm:w-20", text: "text-xl sm:text-2xl", subtext: "text-xs sm:text-sm" },
  };
  const s = sizes[size] || sizes.md;
  const resolvedSrc = logoUrl ? thumbUrl(logoUrl) : "/maahad-logo.png";
  const inner = (
    <div className={`flex items-center gap-2 sm:gap-3 ${className}`} data-testid="logo">
      <div className={`${s.box} rounded-xl overflow-hidden shrink-0 ring-1 ring-border bg-navy`}>
        <img
          src={resolvedSrc}
          alt="Maahad Bursa"
          className="h-full w-full object-cover"
          draggable={false}
          onError={(e) => { e.currentTarget.src = "/maahad-logo.png"; }}
        />
      </div>
      {showText && (
        <div className="flex flex-col leading-tight min-w-0">
          <span className={`${s.text} font-heading font-bold tracking-tight whitespace-nowrap`}>eLearningSaham</span>
          <span className={`${s.subtext} text-muted-foreground tracking-widest uppercase mt-0.5 whitespace-nowrap`}>by Maahad Bursa</span>
        </div>
      )}
    </div>
  );
  if (linkTo) return <Link to={linkTo}>{inner}</Link>;
  return inner;
}
